import * as React from 'react'
import styled from 'styled-components'
import colors from '../../globals/colors'

const Dot = styled.div<{ state: string }>`
    height: 20px;
    width: 20px;
    min-width: 20px;
    border-radius: 20px;
    background-color: ${p => p.state};
`
const Line = styled.div<{ completed: boolean }>`
    height: 2px;
    width: 20px;
    background-color: ${p => p.completed ? colors.dark : colors.light};
`

const Title = styled.span`
    margin-right: 8px;
    margin-left: 4px;
    color: ${colors.grayText};
    font-size: 13px;
    white-space: nowrap;
`
const TitleBox = styled.div`
    transition: all 350ms ease;
`
const completedColor = colors.dark
const activeColor = colors.primary
const incompleteColor = colors.light

enum StepStates { Active, Incomplete, Completed }

const DotWithHover: React.FC<{ state: StepStates, title: string }> = ({ state, title }) => {
    const [hoverState, setHover] = React.useState(false)

    const getColor = () => {
        if (state === StepStates.Active) return activeColor
        if (state === StepStates.Incomplete) return incompleteColor
        return completedColor
    }

    const hover = state == StepStates.Active || hoverState

    return (
        <>
            <Dot state={getColor()} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)} onClick={() => setHover(!hover)} />
            <TitleBox style={{ width: hover ? 'auto' : 0 }}>
                <Title>{hover && title}</Title>
            </TitleBox>
        </>
    )
}

type StepperProps = {
    steps: string[],
    activeStepIndex: number,
}

const default_height = 30

const Stepper: React.FC<StepperProps> = ({ steps, activeStepIndex }) => {

    return (
        <ul style={{ display: 'flex', height: 30, flexWrap: 'wrap' }}>

                {steps.map((item, key) => {
                    const active = key === activeStepIndex
                    const state = key < activeStepIndex ? StepStates.Completed : StepStates.Incomplete
                    return (
                        <li  key={key} style={{display:'flex',alignItems: 'center'}}>
                            <DotWithHover state={active ? StepStates.Active : state} title={item} />
                            {key < (steps.length - 1) && <Line  completed={!active && state === StepStates.Completed} />}
                        </li>
                    )
                })}

        </ul>
    )
}

export default Stepper